module.exports = __webpack_public_path__ + "img/ar.3df0690e.png";